/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <b-card v-show="canShowValue" v-html="attribute.value">
    <b-card-header header-tag="header" role="tab">
      <button v-b-toggle="'accordion-' + attribute.key" class="btn btn-none accordion-title d-flex align-items-center justify-content-between">
        <div class="title">{{attribute.label}}</div>
        <svg class="o-icon"><use xlink:href="#plus-circle"></use></svg>
      </button>
    </b-card-header>
    <b-collapse :id="`accordion-${attribute.key}`" accordion="info-product" role="tabpanel">
      <b-card-body>
        <div class="attribute-wrapper">
          <div class="attribute-row">
            <div v-html="attribute.value"></div>
          </div>
        </div>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  name: 'AccordionSustainability',
  props: {
    attribute: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    variantSelected: {
      type: Array | Object,
      required: false
    }
  },
  computed: {
    canShowValue () {
      // show it if -> hasRespectLabel exist ans is true
      return this.product && this.product.hasRespectLabel
    }
  }
}
</script>
